import { useEffect, useState, useRef } from 'react';
import { Card, CardBody, CardFooter, Col, Form, Row } from 'react-bootstrap';
import { CaretDown, CaretUpFill } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import { ownSubscribe, sendMessage, unSubscribe } from '../../stomp/StompSocket';
import { getFromCache } from '../../util/BullCache';
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import MasterDropdown from '../components/MasterDropdown';

function AddOrder(props) {

  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isBuy, setIsBuy] = useState(props.isBuy);
  const [orderType, setOrderType] = useState('MARKET');
  const [clientId, setClientId] = useState(0);
  const [price, setPrice] = useState(0);
  const [userPrice, setUserPrice] = useState(0);
  const [ip, setIp] = useState('');
  const [lot, setLot] = useState(1); 
  const [qty, setQty] = useState(0); 
  const [qtyChange, setQtyChange] = useState(false); 

    const getISTDateTime = () => {
      const now = new Date();
      const offsetIST = 5.5 * 60 * 60 * 1000; 
      const istTime = new Date(now.getTime() + offsetIST)
        .toISOString()
        .slice(0, 16);
  
      return istTime;
    };
  const [dateTime, setDateTime] = useState(getISTDateTime()); 

  var mkw = props.mkw;
  var user = getFromCache('user');
  var scriptId = (props.mkw.id);


  function findScriptById(scriptId) {
    var allScripts = getFromCache('allScripts') || {};

    for (const market in allScripts) {
      if (allScripts.hasOwnProperty(market)) {
        for (const commodity in allScripts[market]) {
          if (allScripts[market].hasOwnProperty(commodity)) {
            const scripts = allScripts[market][commodity];

            const selectedScript = scripts.find(script => script.id === scriptId);

            if (selectedScript) {
              return selectedScript;
            }
          }
        }
      }
    }

    return null;
  }
  const script = findScriptById(scriptId);

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };

 const handleDateTimeChange = (e) => {
    const newDate= e.target.value; 
    setDateTime(newDate)
  };

  const handleLotChange = (e) => {
    const newLot = e.target.value ? parseFloat(e.target.value) : ''; // Ensure it defaults to 1 if empty
    setLot(newLot); // Update lot value

  };

const isUserChangingQty = useRef(false);

const handleQtyChange = (e) => {
  isUserChangingQty.current = true; // Mark that the user is changing QTY
  const value = e.target.value;
  const rawLot = value ? parseFloat(value) / script.quantity : '';
 const newLot = rawLot !== '' ? (Math.round(rawLot * 100) / 100).toFixed(2) : '';
  setLot(newLot);
  setQty(value);
};

useEffect(() => {
  if (script && lot) {
    if (!isUserChangingQty.current) {
      setQty((lot * script.quantity));
    }
    isUserChangingQty.current = false; // Reset after useEffect runs
  }
}, [lot, script?.quantity]);

  useEffect(() => {
    if (orderType === 'MARKET') {
      setPrice(parseFloat(mkw.i4).toFixed(2)); // Initialize price with ASK RATE for MARKET orders
    }
  }, [orderType, mkw.i4]); // Re-run whenever orderType or mkw.i4 changes
  
  useEffect(() => {
    ownSubscribe('/user/topic/addorder', function (msg) {

      if (msg.body) {
        
        var orderResp = JSON.parse(msg.body);
        if (orderResp.code === 1) {

          Swal.fire({
            icon: "success",
            text: "Order placed!"
          });
        } else if (orderResp.code === 0) {
          Swal.fire({
            icon: "error",
            html: orderResp.messages
          });
        } else {
          Swal.fire({
            icon: "error",
            text: "Order not placed.... Please contact administrator!"
          });
        }
      }
    }, 'addorder-sub-id');
    return () => {
      unSubscribe('addorder-sub-id');
    }
  }, []);

  function buyOrder() {
    if(!validateLot()){
       Swal.fire({
              icon: 'error',
              text: 'Lot in invalid!'
          });

      return; 
    }
    if(selectedClient) {
      var type = 'Buy-MP';
      var rate = props.mkw.i4;
      if (orderType === 'LIMIT') {
        type = rate > price ? 'Buy-RL' : 'Buy-SL';
        rate = price;
      }
      var order = {
        "orderType": type, "quantity": qty, lot: lot,
        "rate": userPrice && userPrice > 0 ? userPrice : rate, "scriptId": props.mkw.id, "userId": selectedClient,
        "inLimit": orderType === 'LIMIT' ? true : false,
        "tradeBy": user.adminId, "device": "Browser", "userAgent": navigator.userAgent,
        "dateTime": userPrice && userPrice > 0 ? dateTime : null, "ip": ip
      };

      sendMessage('/app/topic/addorder', JSON.stringify(order));
   } else {
    Swal.fire({
              icon: 'error',
              text: 'Please select client!'
          });
   }
  };
  function sellOrder() {
    if(!validateLot()){
       Swal.fire({
              icon: 'error',
              text: 'Lot in invalid!'
          });

      return; 
    }
    if(selectedClient) {
      var type = 'Sell-MP';
      var rate = props.mkw.i2;
      if (orderType === 'LIMIT') {
        type = rate < price ? 'Sell-RL' : 'Sell-SL';
        rate = price;
      }
      var order = {
        "orderType": type, "quantity": qty, lot: lot,
        "rate":  userPrice && userPrice > 0 ? userPrice : rate, "scriptId": props.mkw.id, "userId": selectedClient,
        "inLimit": orderType === 'LIMIT' ? true : false,
        "tradeBy": user.adminId, "device": "Browser", "userAgent": navigator.userAgent,
        "dateTime": userPrice && userPrice > 0 ? dateTime : null, "ip": ip
      };

      sendMessage('/app/topic/addorder', JSON.stringify(order));
    } else {
      Swal.fire({
                icon: 'error',
                text: 'Please select client!'
            });
     }  
  };


function validateLot(){
  var valid = true;
  if(script.sn.split("#")[0] === 'MCX'){
    if( lot % 1 !== 0){
      valid = false;
    }
  }
  return valid;
}

  return (<>

    {props.show ? <Card style={{
      zIndex: 100, bottom: '0', marginBottom: '2%', position: 'fixed',
      width: '90%'
    }} className='ms-5 border-0 mb-5 ' bg={isBuy ? 'primary' : 'danger'}>
      <CardBody className=''>
        <Row>
          <Col xs={3} className='text-center fss-1 mt-3'>
            <Form.Label size="sm">{' ' + mkw.e + ' ' + mkw.s + ' ' + mkw.ix}</Form.Label>
          </Col>

          <Col xs={1} className="p-1">
            <Card className={`w-auto summary-card ${mkw.si2 === '1' ? "red-c" : "blue-c"}`}>
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    BID RATE
                    <br />
                    < td onClick={e => this.showModal()}> <div  >{parseFloat(mkw.i2).toFixed(2)}</div></td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className={`w-auto summary-card ${mkw.si4 === '1' ? "red-c" : "blue-c"}`}>
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    ASK RATE
                    <br />
                    <td> <div >{parseFloat(mkw.i4).toFixed(2)}</div></td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className={`w-auto summary-card ${mkw.si6 === '1' ? "red-c" : "blue-c"}`}>
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    LTP
                    <br />
                    <td> <div >{parseFloat(mkw.i6).toFixed(2)}</div></td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className="w-auto summary-card">
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    CHANGE (%)
                    <br />
                    <td>{parseFloat(mkw.i20).toFixed(2)}</td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className="w-auto summary-card">
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    NET
                    <br />
                    <td>  {mkw.i19 < 0 ? <CaretDown style={{ color: 'red' }} /> : <CaretUpFill style={{ color: 'green' }} />} {parseFloat(mkw.i19).toFixed(2)}</td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className="w-auto summary-card">
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    HIGH
                    <br />
                    <td>{parseFloat(mkw.i9).toFixed(2)}</td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className="w-auto summary-card">
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    LOW
                    <br />
                    <td>{parseFloat(mkw.i10).toFixed(2)}</td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className="w-auto summary-card">
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    OPEN
                    <br />
                    <td>{parseFloat(mkw.i11).toFixed(2)}</td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={1} className="p-1">
            <Card className="w-auto summary-card">
              <Card.Body className="pt-1 p-0">
                <Row className="m-0">
                  <Col className="text-center fss-08" style={{ whiteSpace: "nowrap" }}>
                    CLOSE
                    <br />
                    <td>{parseFloat(mkw.i12).toFixed(2)}</td>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
       
        <Row className='mt-1'>
          <Col xl={2}  md={2} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <Form.Check
              type={'radio'}
              label={'BUY'}
              checked={isBuy}
              onChange={e => setIsBuy(true)}
            />
            <Form.Check
              type={'radio'}
              label={'SELL'}
              checked={!isBuy}
              onChange={e => setIsBuy(false)}
            />
          </Col>
          <Col xl={2} md={2} ><label >LOT</label></Col>
          <Col xl={2} md={2} ><label >QTY</label></Col>
          {orderType == 'LIMIT' ?
            <>
              <Col xl={2} md={2} ><label >PRICE</label></Col>
            </> : ""}
            {user.adminType == 'SUPER_ADMIN' || (user.adminType == 'SUPER_MASTER' && user.canAccess != null && user.canAccess)?
            <>
              <Col xl={2} md={2} ><label >USER PRICE</label></Col>
              <Col xl={2} md={2} ><label >DATE TIME</label></Col>
              <Col xl={2} md={2} ><label >IP</label></Col>
            </> : ""}
        </Row>

        <Row>
          <Col xl={2} md={2} >
            <Form.Select aria-label="Default select example" className='bg-light text-black' size='sm' onChange={e => { setOrderType(e.target.value); }}>
              <option>MARKET</option>
              <option>LIMIT</option>
            </Form.Select>
          </Col>
          <Col xl={2} md={2} > <Form.Control size="sm" type="number" className='bg-light text-black' min={1} onChange={handleLotChange} value={lot} /></Col>
          <Col xl={2} md={2} > <Form.Control size="sm" type="number" className='bg-light text-black' value={qty} onChange={handleQtyChange} placeholder="QTY" /></Col>
          {orderType == 'LIMIT' ?
            <>
              <Col xl={2} md={2} > <Form.Control size="sm" type="number" className='bg-light text-black' min={1} placeholder="PRICE" value={price} disabled={orderType === 'MARKET'} onChange={e => setPrice(e.target.value)} /></Col>
            </> : ""}
            {user.adminType == 'SUPER_ADMIN' || (user.adminType == 'SUPER_MASTER' && user.canAccess != null && user.canAccess) ?
            <>
              <Col xl={2} md={2} > <Form.Control size="sm" type="number" className='bg-light text-black' min={1} placeholder="PRICE" onChange={e => setUserPrice(e.target.value)}   /></Col>
              <Col xl={2} md={2} > <Form.Control size="sm" type="datetime-local"  step="1"   className='bg-light text-black' min={1} value={dateTime} onChange={e=> handleDateTimeChange(e)} onClick={(e) => e.target.showPicker && e.target.showPicker()}  /></Col>
              <Col xl={2} md={2} > <Form.Control size="sm" type="text" className='bg-light text-black' placeholder="IP" onChange={e => setIp(e.target.value)}   /></Col>
            </> : ""}  
          
        </Row>

        <Row className='mt-2'>
          {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
            <>
              <Col xl={2} md={2} >
                <label >ADMIN</label> <br />
                <AdminDropdown
                  menuPlacement='top'
                  adminId={user.adminId}
                  setSelectedOption={setSelectedAdmin} />
              </Col>
            </> : ""}

          {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER'?
            <>
              <Col xl={2} md={2} >
                <label >MASTER</label> <br />
                <MasterDropdown
                  menuPlacement='top'
                  adminId={user.adminId}
                  selectedAdmin={selectedAdmin}
                  setSelectedOption={setSelectedMaster}
                  setSelectedMaster={setSelectedMaster}
                  setSelectedBrokerId={setSelectedBrokerId}

                />
              </Col>
            </> : ""}

          {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
            <>
              <Col xl={2} md={2} >
                <label >BROKER</label> <br />
                <BrokerDropdown
                  menuPlacement='top'
                  selectedAdmin={selectedAdmin}
                  selectedMaster={selectedMaster}
                  setSelectedOption={setSelectedBrokerId}
                  setSelectedBrokerId={setSelectedBrokerId}
                  setSelectedSubBrokerId={setSelectedSubBrokerId}
                />
              </Col>
            </> : ""}



          <Col xl={2} md={2} >
            <label >CLIENT</label> <br />
            <ClientDropdown
              menuPlacement='top'
              selectedAdmin={selectedAdmin}
              selectedMaster={selectedMaster}
              selectedBrokerId={selectedBrokerId}
              setSelectedOption={handleSelectedClientChange}
            />
          </Col>
   
          <Col xl={2} md={4}  className='mt-4'>
              <Button variant="success" size='sm' className='me-2' onClick={e => isBuy ? buyOrder() : sellOrder()}>SUBMIT</Button>
              <Button variant="danger" size='sm' onClick={e => { setLot(1); setOrderType('MARKET'); props.onHide() }}>CANCEL</Button>
          </Col>
        
        </Row>
       
      </CardBody>
      <CardFooter></CardFooter>
    </Card> : null}</>);
}
export default AddOrder;